import { Box, type SxProps, type Theme } from '@mui/material';
import { BOX_PATH, BRAND_NAVY, BRAND_ORANGE, LOGO_HEIGHT, LOGO_WIDTH, MARK_HEIGHT, MARK_WIDTH, PREP_PATH, TICK_PATH, TRADE_PATH } from './brandPaths';

/**
 * The TradePrep logo. Navy parts follow the colour scheme (white in dark mode,
 * or always white with `onDark`); the tick and "Prep" stay orange.
 * `markOnly` draws just the box and tick.
 */
export function BrandLogo({ height = 32, onDark = false, markOnly = false, sx }: { height?: number; onDark?: boolean; markOnly?: boolean; sx?: SxProps<Theme> }) {
  const w = markOnly ? MARK_WIDTH : LOGO_WIDTH;
  const h = markOnly ? MARK_HEIGHT : LOGO_HEIGHT;
  return (
    <Box
      component="svg"
      viewBox={`0 0 ${w} ${h}`}
      role="img"
      aria-label="TradePrep"
      sx={[
        (theme) => ({ display: 'block', height, width: (height * w) / h, color: onDark ? '#fff' : BRAND_NAVY, ...(!onDark && theme.applyStyles('dark', { color: '#fff' })) }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <path d={BOX_PATH} fill="none" stroke="currentColor" strokeWidth={10} />
      <path d={TICK_PATH} fill={BRAND_ORANGE} />
      {!markOnly && (
        <>
          <path d={TRADE_PATH} fill="currentColor" />
          <path d={PREP_PATH} fill={BRAND_ORANGE} />
        </>
      )}
    </Box>
  );
}
